import 'react-app-polyfill/ie11';
import React, { useEffect } from "react";
import { Typography, Card, CardActionArea, CardContent, CardMedia, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// Aktiveringsfunktioner
const ActivateSappaPlay = () => window.location.href = "https://www.sappaplay.se/create-account";
const ActivateViaplay = () => window.location.href = "/viaplay";
const ActivateDisney = () => window.location.href = "/disney";
const ActivateTV4Play = () => window.location.href = "/tv4play";
const ActivateSkyShowtime = () => window.location.href = "/skyshowtime";
const ActivateReadly = () => window.location.href = "/readly";
const ActivatePodme = () => window.location.href = "/podme";

const useStyles = makeStyles(() => ({
  gridContainer: {
    justifyContent: 'center',
    display: 'flex',
    flexWrap: 'wrap',
  },
  actionArea: {
    borderRadius: 16,
    transition: '0.2s',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  card: {
    borderRadius: 16,
    width: '100%',
    boxShadow: '0px 4px 8px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  content: {
    backgroundColor: '#003B4A',
    padding: '1rem',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    height: '150px',
    objectFit: 'contain',
    backgroundColor: '#fff',
  },
  cardTitle: {
    color: '#fff',
    fontWeight: 600,
    fontSize: '1.2rem',
  },
  logo: {
    maxWidth: '300px',
    width: '80%',
    height: 'auto',
    marginBottom: '1rem',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },  
}));

function ActivateSelection() {
  const classes = useStyles();

  useEffect(() => {
    // Lägg till logik här vid behov
  }, []);

  const cards = [
    { title: 'Sappa Play', img: './images/SappaPlay.png', onClick: ActivateSappaPlay },
    { title: 'Viaplay', img: './images/selection_viaplay.png', onClick: ActivateViaplay },
    { title: 'Disney+', img: './images/selection_disneyplus.png', onClick: ActivateDisney },
    { title: 'TV4 Play', img: './images/tv4play.jpg', onClick: ActivateTV4Play },
    { title: 'SkyShowtime', img: './images/SkyShowtimeSelection.png', onClick: ActivateSkyShowtime },
    { title: 'Readly', img: './images/Selection_Readly.png', onClick: ActivateReadly },
    { title: 'Podme', img: './images/Selection_Podme.png', onClick: ActivatePodme },
  ];

  return (
    <div className="container" style={{ margin: '0 30px 150px 30px' }}>
      <header className="App-header" style={{ paddingTop: '30px', textAlign: 'center' }}>
        <img
          src={require('./images/Sappa_Green.png')}
          alt="Sappa logo"
          className={classes.logo}
        />
        <p>Välkommen, välj vilken tjänst du vill aktivera</p>

        <div style={{ marginTop: 30 }}>
          <Grid container spacing={3} className={classes.gridContainer}>
            {cards.map((card, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card className={classes.card} onClick={card.onClick}>
                  <CardActionArea className={classes.actionArea}>
                    <CardMedia
                      component="img"
                      className={classes.image}
                      image={require(`${card.img}`)}
                      alt={card.title}
                    />
                    <CardContent className={classes.content}>
                      <Typography className={classes.cardTitle}>
                        {card.title}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </div>
      </header>
    </div>
  );
}

export default ActivateSelection;
